import { AppContextState, INITIAL_STATE, AppDevice } from "./AppContext.ts";
import { Breakpoint } from "@mui/material";
import { AuthTempInfo, AuthUser } from "@/types/Auth.ts";
import { AdminRole, RolePermission } from "@/types/AppRole.ts";
import { AppUtils } from "@/utils/AppUtils.ts";
import { ControlPanelUser } from "@/types/ControlPanel";

type AppContextActions =
  | { type: "setAuthUser"; payload: AuthUser }
  | { type: "setControlPanelUser"; payload: ControlPanelUser }
  | { type: "setAuthTempInfo"; payload: AuthTempInfo }
  | { type: "setUserRoles"; payload: AdminRole[] }
  | { type: "setLoaded"; payload: boolean }
  | { type: "setMenuOpen"; payload: boolean }
  | { type: "setBreakPoint"; payload: Breakpoint }
  | { type: "setDevice"; payload: AppDevice }
  | { type: "cleanState" };

export const AppReducer = (
  state: AppContextState,
  action: AppContextActions
): AppContextState => {
  switch (action.type) {
    case "setAuthUser":
      return {
        ...state,
        auth: { ...state.auth, user: action.payload },
      };

    case "setControlPanelUser":
      return {
        ...state,
        controlPanelUser: action.payload,
      };

    case "cleanState": {
      return {
        ...INITIAL_STATE,
      };
    }

    case "setLoaded": {
      return {
        ...state,
        loaded: action.payload,
      };
    }

    case "setAuthTempInfo": {
      return {
        ...state,
        auth: { ...state.auth, tempInfo: action.payload },
      };
    }

    case "setUserRoles": {
      const roles = action.payload;
      const permissions: RolePermission[] = [];

      roles.forEach((role) => {
        const rolePermissions = Array.from(role?.permissions ?? []);
        for (const permission of rolePermissions) {
          if (
            !permissions.some((x) => AppUtils.compareObjects(permission, x))
          ) {
            permissions.push(permission);
          }
        }
      });
      return {
        ...state,
        auth: { ...state.auth, roles, permissions },
      };
    }

    case "setMenuOpen":
      return {
        ...state,
        menu: { ...state.menu, open: action.payload },
      };

    case "setBreakPoint":
      return {
        ...state,
        layout: { ...state.layout, breakpoint: action.payload },
      };

    case "setDevice":
      return {
        ...state,
        layout: { ...state.layout, device: action.payload },
      };

    default:
      return state;
  }
};
